
export const INPUT_REFUND_DATA = 'input_refund_data';

export const CONFIRM_REFUND = 'confirm_refund';




// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/partial-refund/task-name.js